const products = [
  {
    id: 1,
    name: "shoes",
    productType: "Running Shoes",
    price: 50,
    rating: 4,
    image: "https://i.ibb.co/4PB794n/zapatilla.webp",
    description: "Nike Air is our iconic innovation that uses pressurized air in a durable, flexible membrane to provide lightweight cushioning. The air compresses on impact and then immediately returns to its original shape and volume, ready for the next impact. We debuted Nike Air in 1979, and we've been continuously evolving and improving it ever since.",
  },
  {
    id: 2,
    name: "Macbook",
    productType: "Apple Mcbook",
    price: 1000,
    rating: 4,
    image: "https://i.ibb.co/RBQ3811/mac.jpg",
    description: "Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels. It is powered by a Core i5 processor and it comes with 12GB of RAM. The Apple MacBook Pro packs 512GB of SSD storage.",
  },
  {
    id: 3,
    name: "Coffee Maker",
    productType: "L14dc19 Black Filter Coffee Machine",
    price: 28,
    rating: 3,
    image: "https://i.ibb.co/nj9sxYd/licuadora.jpg",
    description: "Coffeemakers or coffee machines are cooking appliances used to brew coffee. While there are many different types of coffeemakers using several different brewing principles, in the most common devices, coffee grounds are placed into a paper or metal filter inside a funnel, which is set over a glass or ceramic coffee pot, a cooking pot in the kettle family.",
  },
  {
    id: 4,
    name: "Sweater",
    productType: "Xbox Christmas Sweater",
    price: 42,
    rating: 5,
    image: "https://i.ibb.co/hMD51kc/xbox-jumper.jpg",
    description: "PC or Mac. Pepsi or Coke. Xbox or…that other console. It isn’t always easy to show your allegiances, especially when you’re bundled up for the holidays, but this jumper will let you make it abundantly clear what type of games you want to find under your tree.",
  },
  {
    id: 5,
    name: "ShoesPika",
    productType: "Shoes Gamer",
    price: 95,
    rating: 4,
    image: "https://i.ibb.co/qpBjFjM/zapatillass.jpg",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
  {
    id: 6,
    name: "Towel",
    productType: "Towel Bathroom",
    price: 20,
    rating: 5,
    image: "https://i.ibb.co/B6xnGQh/toalla.jpg",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
  {
    id: 7,
    name: "dryer brush",
    productType: "Dryer Brush",
    price: 250,
    rating: 4,
    image: "https://i.ibb.co/N7D9FbD/cepillo-secador.webp",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
  {
    id: 8,
    name: "mountain gloves",
    productType: "MountainGloves",
    price: 25,
    rating: 2,
    image: "https://i.ibb.co/sbRsPrm/guantes.jpg",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
  {
    id: 9,
    name: "mountain bike",
    productType: "Mountaint Bike",
    price: 450,
    rating: 5,
    image: "https://i.ibb.co/fG2K5x1/bici.jpg",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
  {
    id: 10,
    name: "Pillow",
    productType: "Pillow",
    price: 100,
    rating: 5,
    image: "https://i.ibb.co/DpSxwjn/almohadas.jpg",
    description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa eius nam expedita? Eos eligendi voluptas deserunt suscipit eius corrupti unde dignissimos, aspernatur consectetur laboriosam voluptatem?",
  },
]

export default products;